import { useContext } from 'react';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { AnalyticsContext } from '@shared/core/analytics/context';

/**
 * Hook for custom component telemetry with beginAdding action.
 *
 * @param componentName - The name of the component (e.g., 'Faq', 'WeatherReport')
 * @param itemType - The item type for extraInfo (e.g., 'faqComponent', 'weatherReportComponent')
 * @returns An object with beginAdding callback
 *
 * @example
 * ```ts
 * const telemetry = useCustomComponentTelemetry('Faq', 'faqComponent');
 * telemetry.beginAdding('Custom page', pageSlug);
 * ```
 */
export const useCustomComponentTelemetry = (componentName: string, itemType: string) => {
  const { track } = useContext(AnalyticsContext);

  const beginAdding = useEventCallback((page: string, pageSlug: string) => {
    track({
      action: 'beginAdding',
      category: 'website',
      pagePrefix: 'admin',
      label: 'Begin Adding',
      page,
      extraInfo: {
        component: componentName,
        itemType,
        pageSlug,
      },
    });
  });

  return { beginAdding };
};
